<template>
    <div class="lookup">
        <van-search v-model="value" placeholder="请输入企业名称查找" @input="onSearch"/>
        <div class="list">
            <div class="li no_li" v-if="congruent && value">
                <p class="no_title">很抱歉，未找到该匹配结果</p>
                <div class="no_body">
                    <div>是否直接选择: <span class="dark">{{value}}</span></div>
                    <span class="dark_dark" @click="choice()">是的</span>
                </div>
            </div>
            <div v-for="(item,index) in records" :key="index" class="li" @click="choose(item)">
                <p class="name" v-html="item.newName"></p>
                <p class="address" v-html="item.newRegisterAddress"></p>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from 'vuex'
    import Vue from 'vue';
    import { Search, PullRefresh, List } from 'vant';

    Vue.use(List);
    Vue.use(Search);
    Vue.use(PullRefresh);
    export default {
        components: {},
        data () {
            return {
                value: '',
                invest_request: {
                    key: ''
                },
                records: [],
                congruent: true
            };
        },
        computed: {
            ...mapGetters('refund', ['getRetreatRequest'])
        },
        watch: {},
        methods: {
            ...mapActions('refund', [
                'getQueryEnterpriseList',
                'setRetreatRequest'
            ]),
            onSearch (value) {
                this.records = []
                this.refresh(value)
            },

            refresh (value) {
                this.getQueryEnterpriseList({ key: value })
                    .then((res) => {
                        // res.data.forEach(element => {
                        //     element.createTime = element.createTime? element.createTime.replace(/T/g,' ').replace(/Z/g,''):''
                        // });
                        res.list.forEach(element => {
                            if (element.name == value) {
                                this.congruent = false
                            }
                            element.newName = element.name.replace(value, '<span class="dark">' + value + '</span>')
                            element.newRegisterAddress = element.address.replace(value, '<span class="dark">' + value + '</span>')
                        });
                        this.records = this.records.concat(res.list);
                    })
                    .catch((res) => {

                    });
            },

            choice () {
                //         shoppingStore: '', // 企业名称
                //   storeId: '', // 企业ID
                //   shoppingAddress: '', // 企业地址
                this.getRetreatRequest.shoppingStore = this.value
                this.getRetreatRequest.storeId = ''
                this.getRetreatRequest.shoppingCityId = ''
                this.setRetreatRequest(this.getRetreatRequest)
                // this.$router.go(-1)
                this.$router.back()
            },

            choose (item) {
                this.getRetreatRequest.shoppingStore = item.name
                this.getRetreatRequest.storeId = item.enterpriseId
                this.getRetreatRequest.shoppingAddress = item.address
                this.getRetreatRequest.cityId = item.regionCode
                this.getRetreatRequest.shoppingCityId = item.regionCode

                this.setRetreatRequest(this.getRetreatRequest)
                // this.$router.go(-1)
                this.$router.back()
            }
        },
        created () {

        },
        mounted () {}
    };
</script>

<style lang="less" scoped>
.lookup{
    .list{
        padding: 12px;
        .li{
            padding: 23px 0 25px;
            position: relative;
            .name{
                color: #333333;
                margin-bottom: 8px;
                font-size: 14px;
            }
            .address{
                color: #999999;
            }
            /deep/.dark{
                color: #26C080;
            }

            .no_title{
                color: #999999;
                margin-bottom: 10px;
                line-height: 17px;
            }
            .no_body{
                color: #333333;
                font-weight: bold;
                display: flex;
                justify-content: space-between;
                line-height: 24px;
                .dark_dark{
                    display: inline-block;
                    padding: 5px 12px;
                    border: 0.5px solid #36B374;
                    border-radius: 4px;
                    color: #36B374;
                    font-weight: normal;
                    line-height: 14px;
                }
            }
        }
        .no_li{
            padding: 9px 0 17px;
        }
        .li::after{
            position: absolute;
            box-sizing: border-box;
            content: ' ';
            pointer-events: none;
            right: 0;
            bottom: 0;
            left: 0;
            border-bottom: 1px solid #EDEDED;
            -webkit-transform: scaleY(.5);
            transform: scaleY(.5);
        }

    }
}
</style>
